import React from "react";
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Stack, TextField } from "@mui/material";
import Cookies from 'universal-cookie';
import LoadingButton from "@mui/lab/LoadingButton";
import _default from "../themes/default";
import getOrdine from "../services/getOrdine";
import DatePickerIta from "./DatePickerMUI";
import SettingsTitle from "./SettingsTitle";
import Loading from "react-loading";
import editConsegna from "../services/editConsegna";
import getGiacenze from "../services/getGiacenze";
import createDDT from "../services/createDDT";
import addReminder from "../services/addReminder";
import getProdottiFornitore from "../services/getProdottiFornitore";
import getOrdineFornitore from "../services/getOrdineFornitore";
import moment from "moment";

const cookies = new Cookies();
var token = cookies.get('token', { path: '/' });
var username = cookies.get('username', { path: '/' });

const groupInput = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 15
}

const style = {
    zIndex: 999,
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 800,
    maxHeight: 600,
    bgcolor: 'white',
    borderRadius: 2,
    border: '0',
    boxShadow: 24,
    p: 4,
    overflowY: 'scroll',
};



export default class MyModalMagazzinoOrdineFornitore extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            ragioneSociale: '',
            data_consegna: '',
            isLoading: true,
            prodotti: [],
        }
    }


    async componentDidMount() {
        {
            this.setState({ isLoading: true });
            token = cookies.get('token', { path: '/' });
            username = cookies.get('username', { path: '/' });

            let giacenze = await getGiacenze(username, token);
            let ordine = await getOrdineFornitore(username, token, this.props.modal.id);
            let prodotti = [];

            prodotti = [...JSON.parse(ordine.prodotti)];

            prodotti = prodotti.map((prodotto, i) => {
                let giacenza = giacenze.find(g => g.id_prodotto === prodotto.id_prodotto);
                return { ...prodotto, giacenza: giacenza ? giacenza.giacenza : 0 }
            });

            this.setState({
                ragioneSociale: ordine.ragione_sociale,
                data_consegna: moment(ordine.data_consegna, 'yyyy-MM-DD').format('DD/MM/yyyy'),
                prodotti,
                isLoading: false,
                linkPdf: ordine.link_pdf,
            })
        }
    }

    close() {
        this.props.onClose();
    }

    render() {
        if (this.state.isLoading) return <Loading />;
        return (
            <Modal
                open={this.props.modal.show}
                onClose={() => this.close()}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Stack direction={"column"} spacing={2} sx={{ flex: 1 }}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            {this.props.title}
                        </Typography>
                        <Stack direction={'row'} spacing={2} sx={{ flex: 1 }} >
                            <TextField fullWidth inputProps={{ readOnly: true}} value={this.state.ragioneSociale} label="Ragione Sociale" variant="outlined" onChange={(e) => this.setState({ ragioneSociale: e.target.value })} InputLabelProps={{ shrink: this.state.ragioneSociale }} />
                        </Stack>

                        <Stack direction='row' spacing={4} sx={{ flex: 1, mb: 3, }}>
                            <DatePickerIta
                                readOnly={true}
                                grow
                                label="Data consegna"
                                startValue={this.state.data_consegna}
                                onValueChange={(date) => {
                                    this.setState({ data_consegna: date });
                                }}
                            />
                        </Stack>

                        {/* PRODOTTI */}
                        <Stack spacing={3} sx={{ flex: 1 }}>
                            <SettingsTitle title="Prodotti" />
                            {/* SELECT PRODOTTI */}
                            <div>
                                {
                                    this.state.prodotti.length > 0 && (

                                        this.state.prodotti.map((el, i) => {
                                            console.log(el)
                                            return (
                                                <div key={i} style={groupInput}>
                                                    <Stack direction={"row"} spacing={1} sx={{ flex: 1 }} >
                                                        <TextField
                                                            fullWidth
                                                            label="Prodotto"
                                                            value={el.label}
                                                            readOnly={true}
                                                            />

                                                        {/* QUANTITA */}
                                                        <TextField
                                                            type="number"
                                                            variant="outlined"
                                                            label={'Quantita'} value={el.quantita}
                                                            InputLbelProps={{ shrink: el.quantita }}
                                                            InputProps={{ readOnly: true }}
                                                            onChange={(e) => {
                                                                let arr = this.state.prodotti
                                                                arr[i].quantita = e.target.value
                                                                this.setState(() => ({ prodotti: arr }), () => this.calcolaTotale());
                                                            }}
                                                        />
                                                    </Stack>
                                                </div>
                                            )
                                        })
                                    )

                                }
                            </div>
                        </Stack>

                        <Stack direction={"row"} spacing={2} sx={{ flex: 1 }} >
                            <LoadingButton fullWidth sx={{ flex: 1, minHeight: 50 }} style={{ backgroundColor: _default.palette.secondary.main }} variant='contained' loading={this.state.isLoading} onClick={() => window.open(this.state.linkPdf, '_blank')}>
                                Visualizza Ordine Fornitore
                            </LoadingButton>
                                
                        </Stack>
                    </Stack>
                </Box>
            </Modal>
        )
    }
}